import { ApiObterUserInfoNc } from '@/api'
import { defineStore } from 'pinia'
import { useKeycloak } from '@/composables/useKeycloak'

import { GetAuthAlternativo, GetLocalUserInfo, SetLocalUserInfo, GetLocalkeycloakToken, GetLocalDelegacao } from '@/localStorage'
import store from '@/store'
import router from '@/router'

const { init } = useKeycloak()

export const Usuarios = defineStore('Usuarios', {
  state: () => ({
    loading: false,
    userInfo: null,
    permissao: null,
    menus: null,
    menuGeral: [
      {
        codigo: '790',
        descricao: 'Autorizações',
        icone: 'pi pi-lock-open',
        itens: [
          {
            codigo: '790-1',
            descricao: 'Grupo de Usuários',
            icone: 'pi pi-users',
            url: '/grupos-usuario',
            acao: 4,
            uid: 1893484202
          }
        ]
      },
      {
        codigo: '792',
        descricao: 'Ajustes e Consultas de Frequência',
        icone: 'pi pi-chart-pie',
        url: '/gestao-periodo',
        acao: 4,
        uid: 1893484333
      },
      {
        codigo: '793',
        descricao: 'Justificativa de Ocorrência',
        icone: 'pi pi-comments',
        url: '/justificativas',
        acao: 4,
        uid: 1893484333
      },
      {
        codigo: '791',
        descricao: 'Histórico de delegação',
        icone: 'pi pi-save',
        url: '/historico-usuario-delegacao',
        acao: 4,
        uid: 1893484333
      },
      {
        codigo: '790',
        descricao: 'Marcação de Ponto',
        icone: 'pi pi-user',
        url: 'AA/AAPortal/MarcacaoDePronto',
        acao: 4
      },
      {
        codigo: '789',
        descricao: 'Relatórios',
        icone: 'pi pi-file',
        itens: [
          {
            codigo: '789-6',
            descricao: 'Agendados',
            icone: 'pi pi-file',
            url: '/relatorios',
            acao: 4,
            uid: -1336615964
          },
          {
            codigo: '789-1',
            descricao: 'Funcionários',
            icone: 'pi pi-file',
            url: '/relatorios-funcionarios',
            acao: 4,
            uid: -1336615964
          },
          {
            codigo: '789-3',
            descricao: 'Histórico de equipagem dos trens',
            icone: 'pi pi-file',
            url: '/relatorios-historico-equipagem-trem',
            acao: 4,
            uid: -1336615964
          },
          {
            codigo: '789-2',
            descricao: 'Jornada de Trabalho',
            icone: 'pi pi-file',
            url: '/relatorios-jornada-trabalho',
            acao: 4,
            uid: -1336615964
          },
          {
            codigo: '789-4',
            descricao: 'Atividades Excedentes',
            icone: 'pi pi-file',
            url: '/relatorios-atividades-excedentes',
            acao: 4,
            uid: -1336615964
          },
          {
            codigo: '789-5',
            descricao: ' Divergência Ponto-OS',
            icone: 'pi pi-file',
            url: '/relatorios-divergencia-ponto',
            acao: 4,
            uid: -1336615964
          },
          {
            codigo: '789-7',
            descricao: 'Críticas de Intrajornda',
            icone: 'pi pi-file',
            url: '/relatorios-criticas-intrajornada',
            acao: 4,
            uid: -1336615964
          },
          {
            codigo: '789-8',
            descricao: 'Atividades',
            icone: 'pi pi-file',
            url: '/relatorios-atividades',
            acao: 4,
            uid: -1336615964
          },
          {
            codigo: '789-9',
            descricao: 'Adicionais',
            icone: 'pi pi-file',
            url: '/relatorios-adicionais',
            acao: 4,
            uid: -1336615964
          },
          {
            codigo: '789-10',
            descricao: 'Divergências',
            icone: 'pi pi-file',
            url: '/relatorios-divergencias',
            acao: 4,
            uid: -1336615964
          },
          {
            codigo: '789-11',
            descricao: 'Críticas de atividade',
            icone: 'pi pi-file',
            url: '/relatorios-criticas-atividade',
            acao: 4,
            uid: -1336615964
          },
          {
            codigo: '789-12',
            descricao: 'Log de eventos',
            icone: 'pi pi-file',
            url: '/relatorios-log-eventos',
            acao: 4,
            uid: -1336615964
          },
          {
            codigo: '789-13',
            descricao: 'Horas Diurnas x Noturnas',
            icone: 'pi pi-file',
            url: '/relatorios-diurnas-noturnas',
            acao: 4,
            uid: -1336615964
          },
          {
            codigo: '789-14',
            descricao: 'Cerca Eletrônica',
            icone: 'pi pi-file',
            url: '/relatorios-cerca-eletronica',
            acao: 4,
            uid: -1336615964
          },
          {
            codigo: '789-15',
            descricao: 'Reconhecimento Facial',
            icone: 'pi pi-file',
            url: '/relatorios-reconhecimento-facial',
            acao: 4,
            uid: -1336615964
          }
        ]
      },

      {
        codigo: '794',
        descricao: 'Atividades',
        icone: 'pi pi-sitemap',
        url: '/atividade-tipo',
        acao: 4,
        uid: 1893484333
      },
      {
        codigo: '795',
        descricao: 'Perfil Frequência',
        icone: 'pi pi-user',
        url: '/funcionario',
        acao: 4,
        uid: 1893484333
      },
      {
        codigo: '796',
        descricao: 'Configuraçõres Gerais',
        icone: 'pi pi-user',
        url: '/configuracoes',
        acao: 4,
        uid: 1893484333
      },
      {
        codigo: '797',
        descricao: 'Período de Apuração',
        icone: 'pi pi-calendar-times',
        url: '/periodos',
        acao: 4,
        uid: 1893484333
      },
      {
        codigo: '798',
        descricao: 'Bloqueio de Subperíodo',
        icone: 'pi pi-calendar-times',
        url: '/bloqueio-subperiodos',
        acao: 4,
        uid: 1893484333
      },
      {
        codigo: '799',
        descricao: 'Desbloqueio de Subperíodo',
        icone: 'pi pi-calendar-times',
        url: '/listar-desbloqueio-periodo',
        acao: 4,
        uid: 1893484333
      },
      {
        codigo: '801',
        descricao: 'Motivos',
        icone: 'pi pi-comments',
        url: '/motivos-indisponibilidade',
        acao: 4,
        uid: 1893484333
      },
      {
        codigo: '802',
        descricao: 'Indisponibilidades',
        icone: 'pi pi-comments',
        url: '/indisponibilidades',
        acao: 4,
        uid: 1893484333
      },
      {
        codigo: '803',
        descricao: 'Ordem de serviço',
        icone: 'pi pi-sort-alt',
        url: '/ordem-servico',
        acao: 4,
        uid: 1893484333
      },
      {
        codigo: '804',
        descricao: 'Consolidação Folha',
        icone: 'pi pi-sort-alt',
        url: '/consolidacao-folha',
        acao: 4,
        uid: 1893484333
      },
      {
        codigo: '805',
        descricao: 'Cerca Eletrônica',
        icone: 'pi pi-sort-alt',
        url: '/cerca-eletronica',
        acao: 4,
        uid: 1893484333
      },
      {
        codigo: '807',
        descricao: 'Reconversão Manual',
        icone: 'pi pi-sync',
        url: '/reconversao-manual',
        acao: 4,
        uid: 1893484333
      },
      {
        codigo: '808',
        descricao: 'Alertas Registro Ponto',
        icone: 'pi pi-calendar-times',
        url: '/alerta',
        acao: 4,
        uid: 1893484333
      },
    ]
  }),
  actions: {
    async ActionObterUserInfoNc() {
      let keyCloakAuth = GetLocalkeycloakToken()
      if (keyCloakAuth != null && keyCloakAuth != undefined) {
        this.loading = true
        await ApiObterUserInfoNc()
          .then((resposta) => {
            this.userInfo = resposta
            SetLocalUserInfo(this.userInfo)
          })
          .finally(() => (this.loading = false))
      }
    },
    async ActionObterUserInfoMain() {
      this.loading = true
      await ApiObterUserInfoNc()
        .then(async (response) => {
          const userInfo = response

          if (userInfo == null || !userInfo.ativo) {
            await router.push('/nao-autorizado')
          } else {
            this.userInfo = userInfo
            SetLocalUserInfo(this.userInfo)
            await router.push('/home')
          }

          return userInfo
        })
        .finally(() => (this.loading = false))
    },
    async ActionAutenticarContaKeycloak() {
      this.userInfo = GetLocalUserInfo()

      if (this.userInfo == null || this.userInfo == undefined) {
        this.loading = true

        if (window.location.href.indexOf('nao-autorizado') == -1 && GetAuthAlternativo().email == null) {
          await init().finally(() => (this.loading = false))
        }
      }
    },

    async ActionAutorizar() {
      const usuario = this.userInfo

      if (usuario != null && usuario.ativo) {
        if (!this.permissao) {
          await router.push('/nao-autorizado')
        }
      } else {
        await router.push('/nao-autorizado')
      }

      SetLocalUserInfo(usuario)
    },

    async ActionPermitido(recurso) {
      let usuario = GetLocalUserInfo()

      let permissao
      if (!usuario.grupos) {
        await router.push('/nao-autorizado')
        return
      }

      console.log('permissoes antes')
      console.log(usuario.grupos[0])
      console.log(usuario.grupos[0].permissoes)

      if (usuario.grupos[0].permissoes.indexOf('799-3') != -1) {
        //XGH
        usuario.grupos[0].permissoes += ',799'
      }
      if (usuario.grupos[0].permissoes.indexOf('792-3') != -1) {
        //XGH
        usuario.grupos[0].permissoes += ',792'
      }
      if (usuario.grupos[0].permissoes.indexOf('801-1-4') != -1) {
        //XGH
        usuario.grupos[0].permissoes += ',801'
      }
      if (usuario.grupos[0].permissoes.indexOf('802-1-4') != -1) {
        //XGH
        usuario.grupos[0].permissoes += ',802'
      }
      if (usuario.grupos[0].permissoes.indexOf('803-1-4') != -1) {
        //XGH
        usuario.grupos[0].permissoes += ',803'
      }
      if (usuario.grupos[0].permissoes.indexOf('805-1-4') != -1) {
        //XGH
        usuario.grupos[0].permissoes += ',805'
      }

       console.log('teste: ' + usuario.grupos[0].permissoes)

      permissao = usuario.grupos[0].permissoes
        .trim()
        .split(',')
        .find((element) => element == recurso)

      if (permissao) {
        this.permissao = true

        return this.permissao
      }
      this.permissao = false

      return this.permissao
    },

    async ActionObterAcessos() {
      const userInfo = GetLocalUserInfo()

      let menusGeral = this.menuGeral
      let menus = []

      let permissoes = []

      var delegacao = GetLocalDelegacao()

      if (delegacao && delegacao != undefined) {
        let grupo = _.find(userInfo.grupos, { gestorId: delegacao })

        if (grupo) {
          if (grupo.permissoes.indexOf('799-3') != -1) {
            //XGH
            grupo.permissoes += ',799'
          }

          if (grupo.permissoes.indexOf('792-3') != -1) {
            //XGH
            grupo.permissoes += ',792'
          }

          if (grupo.permissoes.indexOf('801-1-4') != -1) {
            //XGH
            grupo.permissoes += ',801'
          }

          if (grupo.permissoes.indexOf('802-1-4') != -1) {
            //XGH
            grupo.permissoes += ',802'
          }
          if (grupo.permissoes.indexOf('803-1-4') != -1) {
            //XGH
            grupo.permissoes += ',803'
          }
          if (grupo.permissoes.indexOf('805-1-4') != -1) {
            //XG
            grupo.permissoes += ',805'
          }

          permissoes = grupo.permissoes.split(',')
        }
      }

      if (permissoes != null && permissoes.length == 0 && userInfo != null && userInfo.grupos != undefined && userInfo.grupos != null) {
        if (userInfo.grupos[0].permissoes.indexOf('799-3') != -1) {
          //XGH
          userInfo.grupos[0].permissoes += ',799'
        }
        if (userInfo.grupos[0].permissoes.indexOf('792-3') != -1) {
          //XGH
          userInfo.grupos[0].permissoes += ',792'
        }
        if (userInfo.grupos[0].permissoes.indexOf('801-1-4') != -1) {
          //XGH
          userInfo.grupos[0].permissoes += ',801'
        }
        if (userInfo.grupos[0].permissoes.indexOf('802-1-4') != -1) {
          //XGH
          userInfo.grupos[0].permissoes += ',802'
        }
        if (userInfo.grupos[0].permissoes.indexOf('803-1-4') != -1) {
          //XGH
          userInfo.grupos[0].permissoes += ',803'
        }

        if (userInfo.grupos[0].permissoes.indexOf('805-1-4') != -1) {
          //XGH
          userInfo.grupos[0].permissoes += ',805'
        }

        permissoes = userInfo.grupos[0].permissoes.split(',')
      }

      permissoes = _.sortBy(permissoes)

      for (const permissao of permissoes) {
        let parents = permissao.split('-')

        if (parents.length == 1) {
          let registro = _.find(menusGeral, { codigo: parents[0] })

          if (registro) {
            let registroExiste = _.find(menus, { codigo: registro.codigo })

            if (!registroExiste) {
              menus.push(registro)
            }
          }
        }

        if (parents.length == 2) {
          let pai = _.find(menusGeral, { codigo: parents[0] })

          if (pai && pai.itens) {
            let itemMenu = _.find(pai.itens, { codigo: permissao })

            if (itemMenu) {
              let paiExiste = _.find(menus, { codigo: pai.codigo })

              if (!paiExiste) {
                let paiMenu = JSON.parse(JSON.stringify(pai))
                paiMenu.itens = []
                paiMenu.itens.push(itemMenu)
                menus.push(paiMenu)
              } else {
                let itemExiste = _.find(paiExiste.itens, {
                  codigo: itemMenu.codigo
                })

                if (!itemExiste) {
                  paiExiste.itens.push(itemMenu)
                }
              }
            }
          }
        }

        if (parents.length == 3) {
          let avo = _.find(menusGeral, { codigo: parents[0] })

          if (avo) {
            let pai = _.find(avo.itens, {
              codigo: `${parents[0]}-${parents[1]}`
            })

            if (pai) {
              let avoExiste = _.find(menus, { codigo: avo.codigo })

              if (!avoExiste) {
                let AvoMenu = JSON.parse(JSON.stringify(avo))
                AvoMenu.itens = []
                AvoMenu.itens.push(pai)
                menus.push(AvoMenu)
              } else {
                let paiExiste = _.find(avoExiste.itens, { codigo: pai.codigo })
                if (!paiExiste) {
                  avoExiste.itens.push(pai)
                }
              }
            }
          }
        }
      }

      menus = _.sortBy(menus, [
        function (o) {
          return o.descricao
        }
      ])

      this.menus = menus
      await this.ActionCarregarInfo()
    },
    async ActionCarregarInfo(grupo) {

      const userInfo = GetLocalUserInfo()
      if (userInfo != undefined) {
        let dados = {
          logotipo: 'https://cdn1.lg.com.br/autoatendimento/3.1.0/img/logotipo.png',
          nomePortal: `Categoria C ${process.env.VUE_APP_VERSAO} ${
            process.env.VUE_APP_AMBIENTE != 'PROD' ? ' - ' + process.env.VUE_APP_AMBIENTE : ''
          }`,
          usuario: {
            nome: userInfo.nome.toUpperCase(),
            foto: 'https://as2.ftcdn.net/jpg/03/46/93/61/220_F_346936114_RaxE6OQogebgAWTalE1myseY1Hbb5qPM.jpg',
            cargo: `(${userInfo.cargo.codigo}) ${userInfo.cargo.descricao.toUpperCase()}`,
            menus: [
              {
                codigo: '99999',
                descricao: 'Sair',
                icone: 'fa fa-sign-out',
                url: '/home',
                uid: 1893484233,
                acao: 4
              }
            ]
          },
          menus: []
        }

        dados.menus = this.menus

        if(grupo)
        {
          console.log('recarregandoMenu')
          await this.ActionObterAcessos();
        }

        store.commit('layout/setDadosLayout', dados)
        store.dispatch('user/getUser', userInfo)
      }
    }
  },
  getters: {
    isAuthenticated: (state) => !!state.userInfo,
    StateUser: (state) => state.userInfo
  }
})
//Forçar deploy
